export function defaultRoute(state) {
  return state.defaultRoute;
}

export function toggleMenu(state) {
  return state.toggleMenu;
}

export function openMenu(state) {
  return state.openMenu;
}

export function filteredMenus(state) {
  const { hostname } = window.location;
  const notAllowedInClippFacil = ['pdv'];
  if (hostname.includes('clipp360')) return state.menus;
  return state.menus.map((menu) => {
    let { children } = menu;
    if (children && children.length) {
      children = children.filter((child) => !notAllowedInClippFacil.includes(child.identifier));
    }
    return { ...menu, children };
  });
}
